import phone from 'assets/images/phone.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { resendConfirm, resendReject } from '../../registration/actions';

export const ResendConfirmationMessage = ({ confirm, reject }) => (
  <div className="modal resend-confirmation-message">
    <img src={phone} className="resend-confirmation-message__image" />
    <h2 className="resend-confirmation-message__header">Resend Confirmation Message</h2>
    <p className="resend-confirmation-message__paragraph">
      Messages may take up to 5 minutes to arrive.
      Still not received your confirmation message?
      You can request another here:
    </p>
    <div className="modal__button-line">
      <Button
        className="modal__button button--secondary"
        onClick={reject}
      >
        Cancel
      </Button>
      <Button
        className="modal__button"
        onClick={confirm}
      >
        Resend
      </Button>
    </div>
  </div>
);

ResendConfirmationMessage.propTypes = {
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  confirm: resendConfirm,
  reject: resendReject
};

export default connect(null, mapDispatchToProps)(ResendConfirmationMessage);
